import type { FC } from 'react';
import type { IconProps as MuiIconProps } from '@mui/material';
import React from 'react';
import MuiIcon from '@mui/material/Icon';

interface IconProps extends MuiIconProps {
  name: string;
}

const Icon: FC<IconProps> = (props) => {
  const { name, ...params } = props;
  return <MuiIcon baseClassName="fas" className={`fa-${name}`} fontSize="small" {...params} />;
};

export default Icon;
